import React, { Component } from 'react';
import MapPostFields from './components/settings/mapPostFields';
import ApiKey from './components/settings/apiKey';
import MapCustomFields from './components/settings/mapCustomFields';
import Alert from './components/blocks/alert';
import { Spring } from 'react-spring';
import { FIELDS } from './data/fields';
import {
  getPostTypes,
  getCustomMeta,
  getOptions,
  updateOption,
  updateAPIKey
} from './services/options';
import './css/flexboxgrid.css';
import './css/AppSettings.css';

class AppSettings extends Component {
  state = {
    apiKey: '',
    postFields: [
      {
        label: 'Post Title',
        name: 'post_title',
        options: FIELDS,
        type: 'select',
        value: ''
      },
      {
        label: 'Post Content',
        name: 'post_content',
        options: FIELDS,
        type: 'select',
        value: ''
      },
      {
        label: 'Post Excerpt',
        name: 'post_excerpt',
        options: FIELDS,
        type: 'select',
        value: ''
      },
      {
        label: 'Post Status',
        name: 'post_status',
        options: ['publish', 'pending', 'draft'],
        type: 'select',
        value: ''
      },
      {
        label: 'Comment Status',
        name: 'comment_status',
        options: ['open', 'closed'],
        type: 'select',
        value: ''
      },
      {
        label: 'Post Type',
        name: 'post_types',
        options: [],
        type: 'select',
        value: ''
      },
      {
        label: 'Post Category',
        name: 'category',
        options: FIELDS,
        type: 'select',
        value: ''
      },
      {
        label: 'Featured Image',
        name: 'featured',
        placeholder: 'Set featured image',
        type: 'checkbox',
        value: 0
      }
    ],
    customMeta: [],
    customFields: [],
    savingChanges: false,
    showAlert: false
  };

  componentDidMount() {
    this.fillPostFields();
    this.fillCustomMeta();
    this.fillOptions();
  }

  handleInputChange = ({ target: { value: apiKey } }) => {
    this.setState({ apiKey });
  };

  handlePostFieldsChange = e => {
    const postFields = [];
    this.state.postFields.forEach(field => {
      if (e.target.name === field.name) {
        if (field.type === 'checkbox') {
          field.value = Number(e.target.checked);
        } else {
          field.value = e.target.value;
        }
      }
      postFields.push(field);
    });
    this.setState({ postFields });
  };

  handleCustomFieldsChange = e => {
    const customFields = [];
    const nameParts = e.target.name.split('_');

    this.state.customFields.forEach(field => {
      const partID = Number(nameParts[1]);
      if (partID === field.id) {
        field[nameParts[0]] = e.target.value;
      }
      customFields.push(field);
    });
    this.setState({ customFields });
  };

  handleFieldAdd = () => {
    const customFields = this.state.customFields;
    const id = customFields.length + 1;
    customFields.push({
      id: id,
      key: '',
      value: ''
    });
    this.setState({ customFields });
  };

  handleFieldDelete = id => {
    const customFields = this.state.customFields;
    customFields.forEach((field, index) => {
      if (field.id === id) {
        customFields.splice(index, 1);
      }
    });
    this.setState({ customFields });
  };

  handleSave = e => {
    e.preventDefault();
    this.setState({ savingChanges: true });
    const customFields = this.trimmedCustomFields();
    this.setState({ customFields }, () => {
      this.updateOptions();
    });
  };

  handleAlertDismiss = () => {
    this.setState({ showAlert: false });
  };

  trimmedCustomFields = () => {
    return this.state.customFields.filter(field => {
      if (field.key === '' || field.value === '') {
        return false;
      }
      return true;
    });
  };

  async fillPostFields() {
    const { data: postTypes } = await getPostTypes();
    const postFields = this.state.postFields.map(field => {
      if (field.name === 'post_types') {
        field.options = postTypes;
        return field;
      }
      return field;
    });
    this.setState({ postFields });
  }

  async fillCustomMeta() {
    const { data: customMeta } = await getCustomMeta();
    this.setState({ customMeta });
  }

  async fillOptions() {
    const {
      data: { gbi_fields: options, gbi_apikey: apiKey }
    } = await getOptions();
    const customfields = options.customfields;

    const customFields = [];
    let fieldIndex = 1;
    for (let field in customfields) {
      customFields.push({
        id: fieldIndex,
        key: field,
        value: customfields[field]
      });
      fieldIndex++;
    }

    const postFields = [];
    this.state.postFields.forEach(field => {
      if (field.type === 'checkbox') {
        field.value = options[field.name] ? 1 : 0;
      } else {
        field.value = options[field.name] ? options[field.name] : '';
      }
      postFields.push(field);
    });

    this.setState({ customFields, postFields, apiKey });
  }

  async updateOptions() {
    const fieldContent = {};
    this.state.postFields.map(field => {
      fieldContent[field.name] = field.value;
      return field;
    });

    const customfields = {};
    this.state.customFields.map(field => {
      customfields[field.key] = field.value;
      return field;
    });

    fieldContent.customfields = customfields;
    await updateOption(fieldContent);
    await updateAPIKey(this.state.apiKey);
    this.setState({ savingChanges: false, showAlert: true });
  }

  render() {
    return (
      <div className="gb-settings">
        {this.state.showAlert && (
          <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
            {props => (
              <div style={props}>
                <Alert
                  message="Changes Saved"
                  onDismiss={this.handleAlertDismiss}
                />
              </div>
            )}
          </Spring>
        )}
        <form onSubmit={this.handleSave}>
          <ApiKey
            value={this.state.apiKey}
            handleInputChange={this.handleInputChange}
          />
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <MapPostFields
                fields={this.state.postFields}
                onFieldChange={this.handlePostFieldsChange}
              />
            </div>
            <div className="col-xs-12 col-md-6">
              <MapCustomFields
                fields={this.state.customFields}
                customMeta={this.state.customMeta}
                onFieldChange={this.handleCustomFieldsChange}
                onFieldDelete={this.handleFieldDelete}
                onFieldAdd={this.handleFieldAdd}
              />
            </div>
          </div>
          <button
            type="submit"
            className="button-primary"
            onClick={this.handleSave}
            disabled={this.state.savingChanges}
          >
            {this.state.savingChanges ? 'Loading...' : 'Save Changes'}
          </button>
        </form>
      </div>
    );
  }
}

export default AppSettings;



// WEBPACK FOOTER //
// ./src/AppSettings.js